// extracted by mini-css-extract-plugin
module.exports = {"document":"SwaggerUi_document_eAttp"};